













import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ComponentsPartsMessages extends Vue {
  @Prop({ type: String, default: '' })
  message: string;

  @Prop({ type: String, default: 'h3' })
  tag: string;

  @Prop({ type: Boolean, default: false })
  error: boolean;

  @Prop({ type: Boolean, default: false })
  showClose: boolean;

  @Prop({ type: Boolean, default: false })
  leftRightPadding: boolean;

  @Prop({ type: Boolean, default: false })
  heightSize: boolean;

  @Prop({ type: String, default: 'big' })
  size: string;

  get classes() {
    const {
      tagClassModificator,
      size,
      error,
      leftRightPadding,
      heightSize,
    } = this;
    return {
      [`messages__${tagClassModificator}`]: true,
      [`messages__${tagClassModificator}_${size}`]: true,
      [`messages__${tagClassModificator}_error`]: error,
      [`messages__${tagClassModificator}_padding`]: leftRightPadding,
      [`messages__${tagClassModificator}_height`]: heightSize,
    };
  }

  get tagClassModificator() {
    return this.tag === 'h3' ? 'header' : 'text';
  }

  closeEmit() {
    this.$emit('closeMessage');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/messages/Messages.vue